import i18n from '../../language/index'
export default {
  version: 1.1,
  animateCombObj: {
    value: 0,
    animate: {
      _key: 'none'
    }
  },
  animateType: 'module_animation',
  pc_widgets_infor: {},
  mb_widgets_infor: {},
  listArr: {
    words: i18n.t('widgets_basic_copyright_style_489'),
    showTag: 'hide',
    make_isShow:'show',
    privacyPolicy:'show',
  }
};



// WEBPACK FOOTER //
// ./src/widgets/basic_copyright/style.js